import { Outlet, useLocation, Navigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/ui/lib/utils";
import { ML_EXPORTS_URL } from "../config/ml-exports-urls";
import { Grid3X3, Settings2, Play } from "lucide-react";

const navItems = [
  { path: ML_EXPORTS_URL.REVIEW, labelKey: "nav.review", icon: Grid3X3 },
  { path: ML_EXPORTS_URL.CONFIGS, labelKey: "nav.configs", icon: Settings2 },
  { path: ML_EXPORTS_URL.RUNS, labelKey: "nav.runs", icon: Play },
] as const;

const MLExportsLayout = () => {
  const location = useLocation();
  const { t } = useTranslation("mlExports");

  if (location.pathname === ML_EXPORTS_URL.ROOT || location.pathname === `${ML_EXPORTS_URL.ROOT}/`) {
    return <Navigate to={ML_EXPORTS_URL.REVIEW} replace />;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="border-b bg-background px-6">
        <nav className="flex gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors",
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                )}
              >
                <Icon className="h-4 w-4" />
                {t(item.labelKey)}
              </Link>
            );
          })}
        </nav>
      </div>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default MLExportsLayout;
